import { useContext } from 'react'
import Empty from '@components/Empty'
import RendererContext, { RendererContextType } from '@contexts/renderer'

const useRenderer = (): RendererContextType => {
  const customRenderer = useContext(RendererContext)

  if (!customRenderer) {
    return Empty
  }

  return customRenderer
}

export default useRenderer
